import AuthService from '@/service/auth/AuthService'
import Vue from 'vue'

export default {
  async call(option) {
    if (option.data != null && option.data.isAwait === false) {
      delete option.data.isAwait
    } else {
      await AuthService.sync()
    }
    return $http(Vue.util.extend({}, option))
  },
  jsonToQueryString(param) {
    let resultString = ''
    try {
      if (typeof param === 'object') {
        let paramNames = Object.getOwnPropertyNames(param)
        if (paramNames.length > 0) {
          resultString += '?'
          paramNames.forEach(name => {
            let value = param[name]
            if (value != null && value.length !== 0) {
              resultString += `${name}=${value}&`
            }
          })
          resultString = resultString.substr(0, resultString.length - 1)
        }
      }
    } catch (e) { }
    return resultString
  }
}
